import React, { useRef, useEffect } from "react";
import Choices from "choices.js";

interface OptionType {
  value: string; // 検索ID
  label: string; // ラベル
}

interface SearchFormProps {
  title: string;
  placeholder: string;
  options: OptionType[];
  onClick: (selectedIds: string[]) => void;
  initialValues?: string[];
}

const SearchForm: React.FC<SearchFormProps> = ({ title, placeholder, options, onClick, initialValues = [] }) => {
  const selectRef = useRef<HTMLSelectElement>(null);
  const choicesRef = useRef<Choices | null>(null);

  useEffect(() => {
    const handleChange = (event: Event) => {
      const target = event.target as HTMLSelectElement;
      const selectedValues = Array.from(target.selectedOptions).map((option) => option.value);
      onClick(selectedValues);
    };

    const selectEl = selectRef.current;
    if (selectEl) {
      choicesRef.current = new Choices(selectEl, {
        removeItemButton: true,
        removeItemButtonAlignLeft: true,
        searchEnabled: true,
        placeholder: true,
        placeholderValue: placeholder,
        noResultsText: "オプションが見つかりません",
        itemSelectText: "",
      });

      selectEl.addEventListener("change", handleChange);
    }

    return () => {
      selectEl?.removeEventListener("change", handleChange);
      if (choicesRef.current) {
        choicesRef.current.destroy();
      }
    };
  }, [options, onClick, placeholder]);

  // 初期値の設定
  useEffect(() => {
    if (choicesRef.current && initialValues.length > 0) {
      choicesRef.current.setChoiceByValue(initialValues);
    }
  }, [initialValues]);

  return (
    <div className="form-group">
      <label className="form-label">{title}</label>
      <div className="input-group">
        <div className="input-group-prepend">
          <span className="input-group-text">
            <i className="fas fa-search"></i>
          </span>
        </div>
        <div style={{ flex: 1 }}>
          <select ref={selectRef} multiple className="form-control">
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default SearchForm;
